var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-dialog-content',[_c('div',{staticClass:"relative flex h-full"},[_c('div',{staticClass:"absolute bottom-0 left-0 right-0 top-4"},[_c('p-loader')],1),_c('iframe',{staticClass:"relative top-0",attrs:{"src":_vm.path,"height":"100%","title":"Invoice pdf","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }